import { GemColor } from './enums/gem-color.enum';
import { SpecialDescriptor } from './enums/gem-special-descriptor.enum';

export const specialDescriptorMap: Record<string, Record<string | GemColor, SpecialDescriptor[]>> = {
  [GemColor.Blue]: {
    Nil: [
      SpecialDescriptor.RoyalBlue,
      SpecialDescriptor.CornflowerBlue,
      SpecialDescriptor.VividBlue,
      SpecialDescriptor.Nil,
    ],
    Green: [SpecialDescriptor.Teal, SpecialDescriptor.Nil],
  },
  [GemColor.Pink]: {
    Nil: [SpecialDescriptor.HotPink, SpecialDescriptor.VividPink, SpecialDescriptor.Nil],
    Orange: [SpecialDescriptor.Padparadscha, SpecialDescriptor.Nil],
    Red: [SpecialDescriptor.HotPink, SpecialDescriptor.Nil],
  },
  [GemColor.Orange]: {
    Pink: [SpecialDescriptor.Padparadscha, SpecialDescriptor.Nil],
    Yellow: [SpecialDescriptor.GoldenOrange, SpecialDescriptor.Nil],
  },
  [GemColor.Red]: {
    Nil: [
      SpecialDescriptor.PigeonBloodRed,
      SpecialDescriptor.RoyalRed,
      SpecialDescriptor.VividRed,
      SpecialDescriptor.Nil,
    ],
  },
  [GemColor.Yellow]: {
    Nil: [SpecialDescriptor.CanaryYellow, SpecialDescriptor.VividYellow, SpecialDescriptor.Nil],
    Pink: [SpecialDescriptor.Peach, SpecialDescriptor.Nil],
    Orange: [SpecialDescriptor.GoldenYellow, SpecialDescriptor.Nil],
  },
  [GemColor.Violet]: {
    Nil: [SpecialDescriptor.LavenderViolet, SpecialDescriptor.VividViolet, SpecialDescriptor.Nil],
  },
  [GemColor.Green]: {
    Blue: [SpecialDescriptor.Teal, SpecialDescriptor.Nil],
  },
  [GemColor.Purple]: {
    Nil: [SpecialDescriptor.VividPurple, SpecialDescriptor.Nil],
  },
};
